import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch } from 'utils/http'

export const useAgencyUpdate = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const updateAgency = async (values: any) => patch(`/management/customers/${customerId}/master`, values)

  return useMutation({
    mutationFn: updateAgency,
    onSuccess: async () => {
      addNotification('Agency plan updated successfully')

      await queryClient.invalidateQueries({ queryKey: ['agencies', customerId] })
    },
  })
}
